import { render } from "./IqraSubscriptionPackagesManagement.vue?vue&type=template&id=4406dcbe"
import script from "./IqraSubscriptionPackagesManagement.vue?vue&type=script&lang=js"
export * from "./IqraSubscriptionPackagesManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__